import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "divide-y divide-gray-100" }
const _hoisted_2 = { class: "w-24 shrink-0 text-sm font-semibold text-gray-700" }
const _hoisted_3 = { class: "flex items-center gap-2" }

import InputField from '@/components/neue/InputField'
import NeueToggle from '@/components/neue/NeueToggle'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import { useSettingsForm } from '@/composables/useSettingsForm'
import SettingsShell from '@/view/settings/SettingsShell.vue'


export default {
  __name: 'SettingsOfficeHours',
  setup(__props) {

const { values, officeHourDays, officeHoursClosed, onOfficeHoursChange, toggleOfficeClosed } = useSettingsForm()

const openingValue = (dayKey, edge) => {
  const value = values[`${dayKey}_office_hours_${edge}`]
  return value === 'closed' ? '' : value
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingsShell, null, {
    default: _withCtx(() => [
      _createVNode(SettingsSection, {
        title: "Office hours",
        description: "The hours your team is available, day by day. Switch a day to Closed when nobody is in."
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(officeHourDays), (day) => {
              return (_openBlock(), _createElementBlock("div", {
                key: day.key,
                class: "flex flex-wrap items-center justify-between gap-x-6 gap-y-3 py-3 first:pt-0 last:pb-0"
              }, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(day.label), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center gap-3", _unref(officeHoursClosed)[day.key] && 'opacity-50'])
                }, [
                  _createVNode(_unref(InputField), {
                    type: "time",
                    class: "w-32",
                    "aria-label": `${day.label} opens`,
                    disabled: _unref(officeHoursClosed)[day.key],
                    "model-value": openingValue(day.key, 'start'),
                    "onUpdate:modelValue": val => _unref(onOfficeHoursChange)(`${day.key}_office_hours_start`, val)
                  }, null, 8, ["aria-label", "disabled", "model-value", "onUpdate:modelValue"]),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-sm text-gray-500" }, "to", -1)),
                  _createVNode(_unref(InputField), {
                    type: "time",
                    class: "w-32",
                    "aria-label": `${day.label} closes`,
                    disabled: _unref(officeHoursClosed)[day.key],
                    "model-value": openingValue(day.key, 'end'),
                    "onUpdate:modelValue": val => _unref(onOfficeHoursChange)(`${day.key}_office_hours_end`, val)
                  }, null, 8, ["aria-label", "disabled", "model-value", "onUpdate:modelValue"])
                ], 2),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(NeueToggle), {
                    "model-value": _unref(officeHoursClosed)[day.key],
                    onChange: val => _unref(toggleOfficeClosed)(day.key, val)
                  }, null, 8, ["model-value", "onChange"]),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-sm text-gray-500" }, "Closed", -1))
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

}